import { isObject } from './is-object';

/**
 * Deep merge two objects.
 *
 * NOTE: This function will not handle circular dependencies and will break.
 *
 * @param target
 * @param ...sources
 */
export function mergeDeep<T>(target: T, ...sources: Array<Partial<T>>): T {
  if (!sources.length) {
    return target;
  }

  const source: Record<string, unknown> = sources.shift() as Record<string, unknown>;

  if (isObject(target) && isObject(source)) {
    const targetObj: Record<string, unknown> = target as Record<string, unknown>;
    for (const key in source) {
      if (isObject(source[key])) {
        if (!targetObj[key]) {
          Object.assign(targetObj, { [key]: {} });
        }

        mergeDeep(targetObj[key] as Record<string, unknown>, source[key] as Record<string, unknown>);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}
